import CharteGraphique from '../../images/pole-identite-visuelle-charte-graphique.png';
import UIUXDesign from '../../images/pole-identite-visuelle-ui-ux-design.png';
import SolutionsWeb from '../../images/pole-technologique-solutions-web.png';

import agfaImg from '../../images/agfa.jpg';
import agfaBigImg from '../../images/agfa_big.jpeg';
import jolotteImg from '../../images/jolotte.jpg';
import yanascopeImg from '../../images/yanascope.jpeg';
import cicBigImg from '../../images/cic_big.jpeg';
import cicImg from '../../images/cic.jpg';
import pagesJaunesImg from '../../images/pagesjaune.jpg';
import gigzImg from '../../images/gigz.jpg';
import shopMeImg from '../../images/shop.me.jpg';
import fairyticsImg from '../../images/fairytics.jpg';

import CicSeriousGame from './fiches/cic-serious-game';
import Jolotte from './fiches/Jolotte';
import Agfa from './fiches/Agfa';
import Yanascope from './fiches/Yanascope';
import ShopMe from './fiches/ShopMe';
import Fairytics from './fiches/Fairytics';

export default {
	'cic-serious-game': {
		img: cicBigImg,
		title: 'CIC - SUD OUEST',
		summary: 'serious game',
		subtitle: "sensibilise ses collaborateurs à l'Épargne Financière",
		description: 'CIC - SUD OUEST a confié à ARCA, accompagné par l\'agence événementielle Supersonik, la conception du serious game "Scènes de Banque": un challenge ludique et créatif !',
		technologies: ['Bootstrap', 'ANGULAR.JS'],
		expertises: [
			{
				pole: 'Identité visuelle',
				src: CharteGraphique
			},
			{
				pole: 'UX / UI Design',
				src: UIUXDesign
			},
			{
				pole: 'Développement appli web',
				src: SolutionsWeb
			}
		],
		objectives: [
			'<em>Développer</em> les comportements « Bourse »',
			' Proposer un <em>outil pédagogique</em>, ludique développant le challenge et le jeu en équipe',
			'<em>Analyser et comprendre</em> les besoins des clients du CIC'
		],
		page: CicSeriousGame,
		previous: { link: 'agfa', src: agfaImg },
		next: { link: 'jolotte', src: jolotteImg }
	},

	agfa: {
		img: agfaBigImg,
		title: 'AGFA Healthcare',
		summary: "refonte de l'identité de leurs produits",
		subtitle: 'refonte ergonomique des outils dans les hôpitaux.',
		description:
			'ARCA Computing a été sollicité pour repenser l’ergonomie et le graphisme de deux outils numériques : l’application Hexagone web et l’interface Kiosque disponible sur des bornes tactiles en hôpitaux.',
		technologies: ['HTML/CSS3', 'SASS', 'Material Design'],
		expertises: [
			{
				pole: 'Identité visuelle',
				src: CharteGraphique
			},
			{
				pole: 'UX / UI Design',
				src: UIUXDesign
			},
			{
				pole: 'Intégration HTML/CSS',
				src: SolutionsWeb
			}
		],
		objectives: [
			'<em>Créer une nouvelle identité graphique,</em> en l\'orientant vers des normes Material Design',
			'Mettre en lumiere les problèmes d\'architecture de l\'information, de guidage, de repérage, de navigation, de cohérence et <em>les corriger</em>',
			'<em>Repenser ergonomiquement et graphiquement</em> les différentes IHM afin d\'axer le nouvel outil vers des usages standards web'
		],
		objectives2: [
			'Définir une <em>charte graphique</em>',
			'Etudier l\'architecture d\'information, proposer une <em>ergonomie et une navigation</em> répondant aux contraintes du support (borne tactile)',
			'<em>Optimiser l\'expérience utilisateur</em> en proposant des IHM claires et intuitives pour des usagers novices en matière d\'utilisation d\'outils web ou tactiles'
		],
		page: Agfa,
		previous: { link: 'jolotte', src: jolotteImg },
		next: { link: 'cic-serious-game', src: cicImg }
	},

	jolotte: {
		img: jolotteImg,
		title: 'Jolotte',
		summary: 'application mobile',
		subtitle: 'l’application mobile de cosmétovigilance.',
		description: 'ARCA Computing a été sollicité pour concevoir une application mobile beauté permettant de composer un vanity virtuel. (En partenariat avec l’agence digitale Limeo Interactive)',
		technologies: ['React Native'],
		expertises: [
			{
				pole: 'UX / UI Design',
				src: UIUXDesign
			},
			{
				pole: 'Développement appli mobile',
				src: SolutionsWeb
			}
		],
		objectives: [
			'<em>Appréhender les cosmétiques au quotidien</em>: conditions d\'utilisation classique, via les rituels de beauté',
			'<em>Les renouveler</em> grâce à un système d\'alerte calculée à partir de la PAO et la DDM',
			'<em>Indiquer</em> tout effet indésirable, grave ou non d\'un produit cosmétique'
		],
		page: Jolotte,
		previous: { link: 'cic-serious-game', src: cicImg },
		next: { link: 'agfa', src: agfaImg }
	},

	// TODO ->
	yanascope: {
		img: yanascopeImg,
		title: 'Yanascope',
		summary: 'application mobile',
		subtitle: 'l’agenda géolocalisé, qui liste tous les évènements près de chez vous.',
		description: 'ARCA Computing a été sollicité pour concevoir une application mobile visant à guider et organiser ses sorties en Guyane. (En partenariat avec l’agence digitale Limeo Interactive)',
		technologies: ['React Native'],
		expertises: [
			{
				pole: 'UX / UI Design',
				src: UIUXDesign
			},
			{
				pole: 'Développement appli mobile',
				src: SolutionsWeb
			}
		],
		objectives: [
			'<em>Proposer une offre</em> de spectacles et de loisirs personnalisée et adaptée aux préférences des utilisateurs',
			'<em>Mettre en avant les acteurs</em> du secteur des loisirs, du spectacle et les artistes en local',
			'Fournir aux partenaires du secteur <em>un espace de communication</em> sous forme de bannières publicitaires'
		],
		page: Yanascope
	},

	'shop.me': {
		img: shopMeImg,
		title: 'Shop.me',
		summary: 'geomarketing',
		subtitle: 'le commerce de proximité devient agile et connecté !',
		description: 'ARCA Computing a créé une solution géomarketing basée sur la technologie des beacons, à la fois compagnon de shopping pour l’utilisateur et outil commercial agile et connecté pour les commerçants.',
		technologies: ['Java', 'Angular', 'MongoDB'],
		expertises: [
			{
				pole: 'Identité visuelle',
				src: CharteGraphique
			},
			{
				pole: 'UX / UI Design',
				src: UIUXDesign
			}
		],
		page: ShopMe
	},
	fairytics: {
		img: fairyticsImg,
		title: 'Fairytics',
		summary: 'communication en temps réelle',
		subtitle: 'envoyez la bonne information, au bon endroit, au bon moment !',
		description: 'Fairytics est la nouvelle solution basée sur les beacons pour communiquer en temps réel avec votre cible par le biais de messages personnalisés.',
		technologies: ['Java', 'Angular', 'MongoDB'],
		expertises: [
			{
				pole: 'Identité visuelle',
				src: CharteGraphique
			},
			{
				pole: 'UX / UI Design',
				src: UIUXDesign
			}
		],
		page: Fairytics
	},
	'pages-jaunes': {
		title: 'Pages Jaunes',
		summary: 'communication interne',
		previous: { link: 'jolotte', src: jolotteImg },
		next: { link: 'gigz', src: gigzImg },
		img: pagesJaunesImg
	},

	gigz: {
		title: 'Gigz',
		summary: 'application mobile',
		previous: { link: 'pages-jaunes', src: pagesJaunesImg },
		next: { link: 'agfa', src: agfaImg },
		img: gigzImg
	}
};



// WEBPACK FOOTER //
// ./src/views/projet/project-details.js